import { gql } from '@apollo/client';

export const PUBNUB_LABEL_CREATED = gql`
  mutation PubNubLabelCreated($label: PubNubLabelModel!) {
    PubNubLabelCreated(label: $label) @client
  }
`;
